"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Input = function Input(_ref) {
  var type = _ref.type,
      placeholder = _ref.placeholder,
      value = _ref.value,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      onKeyPress = _ref.onKeyPress,
      onKeyDown = _ref.onKeyDown,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      onClickIcon = _ref.onClickIcon,
      maxLength = _ref.maxLength,
      disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form--group"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form--input-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: type,
    maxLength: maxLength,
    placeholder: placeholder,
    value: value,
    onBlur: onBlur,
    onChange: onChange,
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown,
    className: "form--input",
    disabled: disabled
  }), icon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form--input-icon-container",
    onClick: onClickIcon
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "form--input-icon"
  }, icon))));
};

var _default = Input;
exports["default"] = _default;